import { BetrokkenStationsBetrokkenheid } from "@/entities/betrokken-stations";

/**
 * Display labels for betrokkenheid types
 */
export const BETROKKENHEID_LABELS: Record<BetrokkenStationsBetrokkenheid, string> = {
    [BetrokkenStationsBetrokkenheid.DEEL_VAN_DOSSIER_TRAJECT]: "Basistraject dossier",
    [BetrokkenStationsBetrokkenheid.DEEL_VAN_DOSSIER_REIKWIJDTE]: "Op basis van reikwijdte van het dossier",
    [BetrokkenStationsBetrokkenheid.VESTIGING]: "Faciliteiten aangevraagd",
    [BetrokkenStationsBetrokkenheid.VSM_BINNEN_TRAJECT]: "Binnen VSM traject",
    [BetrokkenStationsBetrokkenheid.VSM_BUITEN_TRAJECT]: "Buiten VSM traject",
    [BetrokkenStationsBetrokkenheid.VSM_DEEL_VAN_OMLEIDING]: "VSM deel van omleiding",
    [BetrokkenStationsBetrokkenheid.VSM_KERING]: "VSM Keringen",
    [BetrokkenStationsBetrokkenheid.OMREIS_ROUTE]: "Omreisroute",
    [BetrokkenStationsBetrokkenheid.TVV]: "Treinvervangend vervoer",
    [BetrokkenStationsBetrokkenheid.EVACUATIE_AFZET_STATION]: "Afzetstation evacuatie",
    [BetrokkenStationsBetrokkenheid.VRIJWILLIGERS]: "Vrijwilligers",
    [BetrokkenStationsBetrokkenheid.MEDEWERKERS_OP_STATION]: "Medewerkers op station",
    [BetrokkenStationsBetrokkenheid.HANDMATIG]: "Handmatig toegevoegd",
};
